import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { UpdateChecklistStepCommand } from './update-checklist-step.command';
import { UpdateChecklistStepResult } from './update-checklist-step.result';

/**
 * Update checklist step use case.
 * Updates the completion status of a checklist step.
 */
@Injectable({ providedIn: 'root' })
export class UpdateChecklistStepUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: UpdateChecklistStepCommand): Observable<UpdateChecklistStepResult> {
    this._state.setUpdatingChecklistStep(true);
    this._state.setErrorChecklistSteps(null);

    return this._repository.updateChecklistStep(command.caseId, command.stepId, command.isCompleted).pipe(
      tap(() => {
        this._state.updateChecklistStepCompletion(command.stepId, command.isCompleted);
        this._state.setUpdatingChecklistStep(false);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorChecklistSteps(error.message || 'Failed to update checklist step');
        this._state.setUpdatingChecklistStep(false);
        return throwError(() => error);
      })
    );
  }
}
